interface MolsonTabPanelProps {
  dataTestId?: string
  children?: React.ReactNode
  index: number
  value: number
}

export const MolsonTabPanel = ({
  dataTestId,
  children,
  index,
  value,
  ...props
}: MolsonTabPanelProps) => {
  return (
    <div data-testid={dataTestId} hidden={value !== index} {...props}>
      {value === index && children}
    </div>
  )
}
